/**
 * userInfo
 */

define('services/common/userInfo',['app', 'angular', 'loginValidation'], function (app, angular, loginValidation) {
    return app.factory('UserInfo', ['$q', '$http', '$window', 'OpenUp', 'OpenOther', 'auiDialog', 'auiChangeTeamAccountService', 'auiTeamAccountService', function ($q, $http, $window, OpenUp, OpenOther, auiDialog, auiChangeTeamAccountService, auiTeamAccountService) {
        var userInfo = {};
        var userRouteInfo = {};
        var ACCOUNTTYPE_EMAIL = 1;// 邮箱类型
        var ACCOUNTTYPE_PHONE = 2;// 手机号类型

        function get() {
            return userInfo;
        }

        function getNickName() {
            var defer = $q.defer();
            if (!userInfo.displayName) {
                auiChangeTeamAccountService.getInfo().then(function (data) {
                    userInfo.displayName = data.displayName;
                    userInfo.loginID = data.loginID;
                    userInfo.portrait = data.portrait;
                    if (data.userStatusFlags) {
                        userInfo.isEAMAccount = (data.userStatusFlags.substring(7, 8) == 1);//取第8位
                    } else {
                        userInfo.isEAMAccount = false;//获取不到默认是非管理式帐号
                    }
                    defer.resolve(userInfo);
                });
            } else {
                defer.resolve(userInfo);
            }
            return defer.promise;
        }

        function promise() {
            var defer = $q.defer();
            if (userInfo.id) {
                defer.resolve(userInfo);
            } else {
                OpenUp.getDeveloperBaseInfo(
                    {req: {}}
                ).then(function (res) {
                    userInfo.id = res.userID;
                    constructDeveloperInfo(userInfo, res.developerInfo);
                    constructIndivInfo(userInfo, res.indivDeveloper);
                    constructCorpInfo(userInfo, res.corpDeveloper);

                    if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                        getUserRouteInfo().then(function (data) {
                            data.userRouteInfoList.forEach(function (userRouteInfo) {
                                if (userRouteInfo.userID == AUI.HDGWCall.getUserInfoValue('teamid')) {
                                    constructMemberAccountInfo(userInfo, userRouteInfo);
                                    defer.resolve(userInfo);
                                }
                            })
                        }).catch(function () {
                            defer.resolve(userInfo);
                        })
                    } else {
                        defer.resolve(userInfo);
                    }

                }).catch(function (data) {
                    if (data && data.NSP_STATUS == 90100017) {
                        auiDialog.fail('鉴权失败', '该团队帐号异常，暂不支持登录管理中心。', function () {
                            AUI.HDGWCall.delUserInfoKey("teamid");
                            AUI.BaseJSUtil.redirectUrl(systemParaConf.user.indexUrl);
                        });
                        defer.resolve({});
                    }
                    defer.resolve({});
                });
            }

            return defer.promise;
        }

        function getUserInfo() {
            var defer = $q.defer();
            updateCache(function (userInfo) {
                var updateInfo = (userInfo.updateInfo ? userInfo.updateInfo : {});
                constructDeveloperInfo(updateInfo, updateInfo.developerInfo);
                constructIndivInfo(updateInfo, updateInfo.indivDeveloper);
                constructCorpInfo(updateInfo, updateInfo.corpDeveloper);
                AUI.BaseJSUtil.mergeJSON(updateInfo, userInfo, 2);
                defer.resolve(userInfo);
            });
            return defer.promise;
        }

        function allowLogin(flag) {
            var defer = $q.defer();

            getUserRouteInfo(!flag).then(function (userRouteInfo) {
                if (!AUI.HDGWCall.getUserInfoValue('teamid') && userRouteInfo.currentUserRouteInfo && userRouteInfo.currentUserRouteInfo.channelRoleTypes && userRouteInfo.currentUserRouteInfo.channelRoleTypes.length > 0) {
                    var count = 0;
                    for (var t = 0; t < userRouteInfo.currentUserRouteInfo.channelRoleTypes.length; t++) {
                        if (userRouteInfo.currentUserRouteInfo.channelRoleTypes[t].roleID == 'PopProxyRole' && (userRouteInfo.currentUserRouteInfo.channelRoleTypes[t].innerStatus == 1 || userRouteInfo.currentUserRouteInfo.channelRoleTypes[t].innerStatus == 2)) {
                            defer.resolve({isAllowLogin: 0, isPopProxyRole: true});
                            return defer.promise;
                        }
                    }
                    for (var h = 0; h < userRouteInfo.currentUserRouteInfo.channelRoleTypes.length; h++) {
                        if (userRouteInfo.currentUserRouteInfo.channelRoleTypes[h].allowLogin == 1) {
                            if (userRouteInfo.currentUserRouteInfo.verifyRealState == 1 && userRouteInfo.currentUserRouteInfo.channelRoleTypes[h].roleID == 'PopProxyRole') {
                                defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userRoleSubmitUrl});
                                return defer.promise;
                            } else if (userRouteInfo.currentUserRouteInfo.verifyRealState == 3) {
                                if (userRouteInfo.currentUserRouteInfo.userType == 1) {
                                    defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userAuthPerUrl});
                                } else {
                                    defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userAuthCorpUrl});
                                }
                                return defer.promise;
                            } else if (userRouteInfo.currentUserRouteInfo.verifyRealState == 0) {
                                defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userAuthSelUrl});
                                return defer.promise;
                            } else {
                                defer.resolve({isAllowLogin: 1});
                                return defer.promise;
                            }
                        } else {
                            count++;
                        }
                    }
                    if (count == userRouteInfo.currentUserRouteInfo.channelRoleTypes.length) {
                        if (userRouteInfo.currentUserRouteInfo.userType) {
                            if (userRouteInfo.currentUserRouteInfo.userType == 1) {
                                defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userAuthPerUrl});
                            } else {
                                defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userAuthCorpUrl});
                            }
                        } else {
                            defer.resolve({isAllowLogin: 1, url: systemParaConf.user.userAuthSelUrl});
                        }
                        return defer.promise;
                    } else {
                        defer.resolve({isAllowLogin: 1});
                    }

                } else {
                    defer.resolve({isAllowLogin: 1});
                }
            }).catch(function () {
                defer.reject();
            });
            return defer.promise;
        }

        function updateUser(settings) {
            var defer = $q.defer();
            OpenUp.update({req: settings}).then(function (data) {
                if (data) {
                    defer.resolve(data);
                }
                updateCache();
            }).catch(function (err) {
                defer.reject(err);
            });

            return defer.promise;
        }

        function changeNameFun(settings) {
            var defer = $q.defer();
            OpenUp.changeName({
                req: settings
            }, true).then(function (data) {
                if (data.error) {
                    defer.reject(data)
                } else {
                    updateCache();
                    defer.resolve(data);
                }
            }).catch(function (data) {
                defer.reject(data);
            });
            return defer.promise;
        }


        function updateBank(settings) {
            var defer = $q.defer();
            OpenUp.updateMerchantInfo({req: settings}, true).then(function (data) {
                if (data) {
                    defer.resolve(data);
                }
                updateCache();
            }).catch(function (data) {
                defer.reject(data);
            });
            return defer.promise;
        }

        /**
         * 调用此接口更新userInfo
         */
        function updateCache(callBackFun) {
            if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                if (typeof callBackFun == 'function') {
                    callBackFun(userInfo);
                }
                return userInfo;
            } else {
                OpenUp.getDeveloperBaseInfo({
                    req: {}

                }).then(function (res) {
                    userInfo = {};
                    userInfo.id = res.userID;
                    //花瓣开关
                    constructDeveloperInfo(userInfo, res.developerInfo);
                    constructIndivInfo(userInfo, res.indivDeveloper);
                    constructCorpInfo(userInfo, res.corpDeveloper);
                    if (typeof callBackFun == 'function') {
                        callBackFun(userInfo);
                    }
                });
            }

            return userInfo;
        }


        //getWhiteListCache 获取白名单缓存
        function getWhiteListCache(callBackFun) {
            if (!userInfo.whiteList) {
                OpenOther.getWhiteList({}).then(function (data) {
                    if (data && data.retCode == 0) {
                        data = encodeURIComponent(JSON.stringify(data));
                        data = JSON.parse(decodeURIComponent(data));
                        userInfo = get();
                        userInfo.whiteList = [];
                        if (data.whiteList.length > 0) {
                            for (var i = 0; i < data.whiteList.length; i++) {
                                userInfo.whiteList.push(data.whiteList[i].rightId);
                            }
                        }
                        if (typeof callBackFun == 'function') {
                            callBackFun(userInfo.whiteList);
                        }
                    }
                });
            } else {
                if (typeof callBackFun == 'function') {
                    callBackFun(userInfo.whiteList);
                }
            }
        }


        /* 原user.js中封装userObj的方法 */
        function constructAcctInfo(dst, acctInfoList) {

            if (!AUI.BaseJSUtil.existy(acctInfoList)) return;

            acctInfoList.forEach(function (v) {
                if (!AUI.BaseJSUtil.existy(v.accountType)) return;
                //邮箱类型
                if (v.accountType == ACCOUNTTYPE_EMAIL) {
                    if (!dst.contactEmail) {
                        dst.contactEmail = v.userAccount;
                    }
                    dst.accountEmail = v.userAccount;
                }
                //手机号类型
                if (v.accountType == ACCOUNTTYPE_PHONE) {
                    if (v.userAccount.substring(0, 4) == '0086') {
                        v.userAccount = v.userAccount.substring(4);
                    }
                    if (!dst.contactPhone) {
                        dst.contactPhone = v.userAccount;
                    }
                    dst.accountPhone = v.userAccount;
                }
            });
        }

        function constructDeveloperInfo(dst, developerInfo) {

            if (!AUI.BaseJSUtil.existy(developerInfo)) return;
            if (AUI.BaseJSUtil.existy(developerInfo.contactPhone) && developerInfo.contactPhone.substring(0, 4) == '0086') {
                developerInfo.contactPhone = developerInfo.contactPhone.substring(4);
            }
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'verifyRealType', 'verifyRealType');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'registerAcct', 'loginName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'province', 'devProvince');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'provinceName', 'provinceName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'city', 'devCity');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'cityName', 'cityName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'lastContactMaintainTime');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactAddress');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'realName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'userType');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactQQ', 'qq');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactMSN', 'msn');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'webURL');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactEmail');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactPhone');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'updateInfo');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'submitRealTime');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'isChangeRealName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'newPayPassDate');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'isDownloadFeeApps');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'isDownloadFeeThemes');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'isSeller');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'verifyRealDesc', 'approveOpinion');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'updateRealState');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'updateBankState');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'verifyRealState');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'verifyBankState');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'realNameEn');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'remark4userinfo');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'learnchannels');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'learnchannelsOther');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'payCertifyStatus');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'commerceCertifyStatus');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'alChgRealName');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'acceptEDM');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'verifyType');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'devName4Inner');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'devNameEn4Inner');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'leftAmtVerifyQuantity');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'leftPayVerifyQuantity');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'msgLang');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'isLegalManMaximizing');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'hwcloudRealname');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'specialAccountType');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'isSupplementalAttachments');
            AUI.BaseJSUtil.copyAttribute(dst, developerInfo, 'contactIdCard');

            if (AUI.BaseJSUtil.existy(developerInfo.devName4Inner)) {
                dst.devName4Inner = developerInfo.devName4Inner;
            }
            if (AUI.BaseJSUtil.existy(developerInfo.devNameEn4Inner)) {
                dst.devNameEn4Inner = developerInfo.devNameEn4Inner;
            }


            if (AUI.BaseJSUtil.existy(developerInfo.attributes2)) {
                var attr2 = developerInfo.attributes2;
                attr2 = typeof attr2 == 'string' ? JSON.parse(attr2) : attr2;
                dst.isMngRenZheng = AUI.BaseJSUtil.existy(attr2.isMngRenZheng) && attr2.isMngRenZheng == 'Y';
                dst.isPlayGuide = ((AUI.BaseJSUtil.existy(attr2.isPlayGuide)) && attr2.isPlayGuide == '1') ? '1' : '0';
            }

            if (AUI.BaseJSUtil.existy(developerInfo.updateInfo)) {
                var updateInfo = developerInfo.updateInfo;
                updateInfo = typeof updateInfo == 'string' ? JSON.parse(updateInfo) : updateInfo;
                dst.updateInfo = updateInfo;

                //设置Model.userInfo.devName4Inner，如果后台没值，页面就显示realname
                if (AUI.BaseJSUtil.existy(dst.updateInfo) && dst.updateInfo.length > 0) {
                    updateInfo = angular.fromJson(angular.copy(dst.updateInfo));
                    var updateInfoDeveloperInfo = angular.fromJson(updateInfo.developerInfo);
                    var devName4Inner = "";
                    var devNameEn4Inner = "";
                    if (AUI.BaseJSUtil.existy(updateInfoDeveloperInfo)) {
                        devName4Inner = updateInfoDeveloperInfo.devName4Inner;
                        devNameEn4Inner = updateInfoDeveloperInfo.devNameEn4Inner;
                        if (AUI.BaseJSUtil.existy(devName4Inner) && devName4Inner.length > 0) {
                            dst.devName4Inner = devName4Inner;
                        }
                        if (AUI.BaseJSUtil.existy(devNameEn4Inner) && devNameEn4Inner.length > 0) {
                            dst.devNameEn4Inner = devNameEn4Inner;
                        }
                    }
                }
            }
        }

        function constructIndivInfo(dst, indivInfo) {
            if (!AUI.BaseJSUtil.existy(indivInfo)) return;

            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'realName', 'perRealName');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'ctfCode', 'perCtfCode');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'attachment1', 'perCtfFg');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'attachment2', 'perCtfBg');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'attachment3', 'perCtf3');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'attachment4', 'perCtfNc');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'province', 'perProvince');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'provinceName', 'perProvinceName');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'provinceName');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'city', 'perCity');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'cityName', 'perCityName');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'cityName');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'indivAddress');
            AUI.BaseJSUtil.copyAttribute(dst, indivInfo, 'ctfExpireDate');
        }

        function constructCorpInfo(dst, corpInfo) {

            if (!AUI.BaseJSUtil.existy(corpInfo)) return;
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'corpName');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'corpProvince');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'corpCity');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'provinceName');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'cityName');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'corpAddress');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'isThreeInOne');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'legalMan');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'legalManCtfCode');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment1', 'corpLicense');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment2', 'tax');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment3', 'corpCode');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment4', 'corpEntityPicFile');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment5', 'corpEntityPicFile1');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment6', 'corpNameChange');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment7', 'contactorImg1');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment8', 'contactorImg2');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment9', 'contactorImg3');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment10', 'contactorImg10');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'attachment11', 'contactorImg11');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'corpBsLicID', 'corpBsLicID');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'corpBsLicExpDate', 'corpBsLicExpDate');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'orgCodeExpDate', 'orgCodeExpDate');
            AUI.BaseJSUtil.copyAttribute(dst, corpInfo, 'legalManCtfExpDate', 'legalManCtfExpDate');
        }

        function constructUserInfo(dst, userInfoTemp) {
            if (!AUI.BaseJSUtil.existy(userInfoTemp)) return;
            AUI.BaseJSUtil.copyAttribute(dst, userInfoTemp, 'nationalCode');
            AUI.BaseJSUtil.copyAttribute(dst, userInfoTemp, 'loginUserName');
        }

        function constructMemberAccountInfo(dst, memberInfo) {
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'realName');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'memberUserID');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'checkExpire');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'createTime');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'countryCode');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'userValidStatus');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'updateTime');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'verifyRealState');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'userType');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'userid', 'userID');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'channelRoleTypes');
            AUI.BaseJSUtil.copyAttribute(dst, memberInfo, 'isChangeRealName');

        }

        //用户注销方法
        function logOut() {
            AUI.HDGWCall.logout();
        }

        //获取当前帐号的团队帐号信息
        function getUserRoute(availableUserRoute, data) {
            var defer = $q.defer();
            //是否检查和控制页面的跳转
            var isCheckAccount = (location.href.indexOf("/console") != -1 || location.href.indexOf("/memberCenter") != -1);

            if (availableUserRoute && angular.isArray(availableUserRoute) && availableUserRoute.length > 0) {
                var roleList = [];
                //当前用户
                var currentUserRouteInfo = {};
                var isInTeam = false;
                var selfRouteInfo = {};
                var ruPersonUserIDs = [];
                var useableUserRoute = [];
                availableUserRoute.forEach(function (item) {
                    if (item.invalid == -1 || item.invalid == 0) {
                        useableUserRoute.push(item)
                    }
                })
                //考虑是服务商的情况  如果是availableUserRoute存在且availableUserRoute.length>0 取第1个 如果是服务商跳转到服务商的界面,直接到他的管理中心去
                var isResellerRole = loginValidation.checkIsResellerRole(useableUserRoute);
                if (isResellerRole) {
                    AUI.HDGWCall.delUserInfoKey("teamid");
                    AUI.BaseJSUtil.redirectUrl(systemParaConf.user.resellerConsole);
                    return defer.promise;
                }
                for (var i = 0; i < availableUserRoute.length; i++) {
                    if (AUI.HDGWCall.getUserInfoValue('teamid') && availableUserRoute[i].userID == AUI.HDGWCall.getUserInfoValue('teamid')) {
                        if (availableUserRoute[i].channelRoleTypes && angular.isArray(availableUserRoute[i].channelRoleTypes)) {
                            for (var t = 0; t < availableUserRoute[i].channelRoleTypes.length; t++) {
                                roleList.push(availableUserRoute[i].channelRoleTypes[t].roleID);
                            }
                            currentUserRouteInfo = availableUserRoute[i];
                        }
                    }
                    if (!availableUserRoute[i].memberUserID) {
                        selfRouteInfo = availableUserRoute[i];
                    }
                    //检查是否属于这个团队
                    if (AUI.HDGWCall.getUserInfoValue('teamid') && availableUserRoute[i].userID == AUI.HDGWCall.getUserInfoValue('teamid')) {
                        isInTeam = true;
                    }
                    //说明是俄罗斯站点的个人且路由表里面没有开发者名称的才加进去
                    if (availableUserRoute[i].innerSiteID == 8 && availableUserRoute[i].userType == 1 && !availableUserRoute[i].realName) {
                        ruPersonUserIDs.push(availableUserRoute[i].userID);
                    }
                }
                //说明没有赋值 当前是主帐号
                if (!currentUserRouteInfo.userID && useableUserRoute.length > 0) {
                    currentUserRouteInfo = useableUserRoute[0];
                    //当前他自己的 且不是切换过来的
                    if (currentUserRouteInfo.memberUserID && !sessionStorage.getItem('isChangeTeamUid') && isCheckAccount) {
                        auiChangeTeamAccountService.changeTeamAccount(currentUserRouteInfo);
                        return defer.promise;
                    } else {
                        currentUserRouteInfo = selfRouteInfo;
                        sessionStorage.removeItem('isChangeTeamUid');
                    }
                    if (currentUserRouteInfo.channelRoleTypes && angular.isArray(currentUserRouteInfo.channelRoleTypes)) {
                        for (var h = 0; h < currentUserRouteInfo.channelRoleTypes.length; h++) {
                            roleList.push(currentUserRouteInfo.channelRoleTypes[h].roleID);
                        }
                    }
                } else {
                    sessionStorage.removeItem('isChangeTeamUid');
                }
                if ((!isInTeam && AUI.HDGWCall.getUserInfoValue('teamid'))) {
                    auiDialog.fail('鉴权失败', '该团队帐号异常，暂不支持登录管理中心。', function () {
                        AUI.HDGWCall.delUserInfoKey("teamid");
                        AUI.BaseJSUtil.redirectUrl(systemParaConf.user.indexUrl);
                    });
                }
                if (AUI.HDGWCall.getUserInfoValue('teamid') || currentUserRouteInfo.userID) {
                    userRouteInfo.userID = (AUI.HDGWCall.getUserInfoValue('teamid') || currentUserRouteInfo.userID);
                }
                userRouteInfo.userRouteInfoList = availableUserRoute;
                userRouteInfo.roleList = roleList;
                userRouteInfo.currentUserRouteInfo = currentUserRouteInfo;
                getRuUserAuthInfo(ruPersonUserIDs).then(function (userAuthInfos) {
                    if (userAuthInfos.length > 0) {
                        userAuthInfos.forEach(function (userAuthInfo) {
                            userRouteInfo.userRouteInfoList.forEach(function (userRouteInfo) {
                                if (userAuthInfo.userID == userRouteInfo.userID) {
                                    userRouteInfo.realName = userAuthInfo.realName;
                                }
                            })
                        })
                    }
                    if (isCheckAccount) {
                        if (currentUserRouteInfo.verifyRealState == 2 || currentUserRouteInfo.verifyRealState == 1) {
                            //说明不是国内的
                            if (AUI.HDGWCall.getZoneId() != sysUrlCfg.siteIDToZoneID['1'].siteID) {
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.siteIDToZoneID[sysUrlCfg.zoneIDToSiteIDMap[AUI.HDGWCall.getZoneId()]].consoleUrl);
                                return;
                            } else {
                                //对活动啥的已经登录过的特殊处理
                                if (currentUserRouteInfo && sysUrlCfg.siteIDToZoneID[(currentUserRouteInfo.innerSiteID || currentUserRouteInfo.siteID)].siteID != AUI.HDGWCall.getZoneId()) {
                                    if (!AUI.HDGWCall.getCookieOrSessionSt("siteid-member") && currentUserRouteInfo.memberUserID) window.sessionStorage.setItem("siteid-member", AUI.HDGWCall.getZoneId());
                                    AUI.HDGWCall.setUserInfoValue("siteid", sysUrlCfg.siteIDToZoneID[(currentUserRouteInfo.innerSiteID || currentUserRouteInfo.siteID)].siteID);
                                    $window.location.reload();
                                    return;
                                }
                                //设置团队帐号相关的cookie
                                AUI.HDGWCall.setCookieForTeamOrUser(currentUserRouteInfo);
                                sessionStorage.setItem("x-uid", currentUserRouteInfo.userID);
                                //处理应用认领  如果没有处理过则走到这里。处理过就不走了
                                if (!AUI.HDGWCall.getUserInfoValue('teamid') && !AUI.HDGWCall.getCookieOrSessionSt("isShowAppClaims")) {
                                    loginValidation.queryClaimsInfo(currentUserRouteInfo, function () {
                                        defer.resolve(userRouteInfo);
                                    }, false);
                                } else if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                                    getIsLegalRole().then(function (flag) {
                                        getIsAdminRole().then(function (isAdmin) {
                                            userRouteInfo.isLegal = flag;
                                            userRouteInfo.isAdmin = isAdmin;
                                            defer.resolve(userRouteInfo);
                                        });
                                    });
                                } else {
                                    defer.resolve(userRouteInfo);
                                }
                            }
                        }
                            //重新实名认证的  这个一定是他自己的  没有团队帐号的信息 //实名认证的驳回的，这个是
                        //敏感引用修改成跳转到不同地址
                        else if ((AUI.HDGWCall.getZoneId() == 1 || AUI.HDGWCall.getZoneId() == 11) && (currentUserRouteInfo.verifyRealState == 0 || currentUserRouteInfo.verifyRealState == 3)) {
                            loginValidation.handleGetUserInfo(function () {
                                AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getZoneId()].verifiedUrl);
                                return;
                            }, data)
                            return;
                        } else {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getZoneId()].verifiedUrl);
                            return;
                        }
                    } else {
                        defer.resolve(userRouteInfo);
                    }

                });
            } else {
                if (isCheckAccount) {
                    if (AUI.HDGWCall.getZoneId() == 1 || AUI.HDGWCall.getZoneId() == 11) {
                        loginValidation.handleGetUserInfo(function () {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getZoneId()].verifiedUrl);
                            return;
                        }, data)
                    } else {
                        AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getZoneId()].verifiedUrl);
                        return;
                    }
                } else {
                    defer.resolve(userRouteInfo);
                }
            }
            return defer.promise;
        }


        //getName 获取俄罗斯个人的开发者名称
        function getUserRouteInfo(flag, allRouteInfo) {
            var defer = $q.defer();
            var availableUserRoute = [];
            //是否检查和控制页面的跳转
            var isCheckAccount = (location.href.indexOf("/console") != -1 || location.href.indexOf("/memberCenter") != -1);
            if (userRouteInfo.userID && !flag) {
                defer.resolve(userRouteInfo);
            } else {
                var routeInfoData = {};
                if (allRouteInfo && allRouteInfo.userRouteInfoList) {
                    var userRouteInfoDataList = [];
                    allRouteInfo.userRouteInfoList.forEach(function (userRouteInfo) {
                        availableUserRoute.push(userRouteInfo)
                        if (userRouteInfo.invalid == -1 || userRouteInfo.invalid == 0) {
                            userRouteInfoDataList.push(userRouteInfo);
                        }
                        routeInfoData.userRouteInfoList = userRouteInfoDataList;
                    })
                    getUserRoute(availableUserRoute, routeInfoData).then(function (data) {
                        if (data) {
                            defer.resolve(data);
                        }
                    }).catch(function () {
                        defer.reject()
                    })
                } else {
                    OpenUp.getUserRouteInfo({req: {}}).then(function (data) {
                        routeInfoData = angular.copy(data);
                        availableUserRoute = data.userRouteInfoList;
                        getUserRoute(availableUserRoute, routeInfoData).then(function (data) {
                            if (data) {
                                defer.resolve(data);
                            }
                        }).catch(function () {
                            defer.reject()
                        })
                    }).catch(function () {
                        //到实名认证去   国内的实名认证还是海外的实名认证
                        if (isCheckAccount) {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.verifiedUrl[AUI.HDGWCall.getZoneId()].verifiedUrl);
                            return;
                        }
                        defer.resolve(userRouteInfo);
                    });
                }

            }
            return defer.promise;
        }

        //获取当前帐号所有团队信息，包含已过期、已失效、有效的团队帐号信息列表
        function getUserAllRouteInfo() {
            var defer = $q.defer();
            OpenUp.getUserAllRouteInfo({req: {}}).then(function (resp) {
                if (resp.resultCode == 0) {
                    if (sysParamCfg.switchConf.isShowEAMType && userInfo.isEAMAccount && resp.userRouteInfoList.length === 0) {//如果是管理式帐号 并且路由表是空的
                        auiDialog.warn('提醒', '您的帐号管理员未进行开发者认证，无权限访问管理中心。', function () {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.indexUrl);
                        });
                        defer.reject();
                    } else if (sysParamCfg.switchConf.isShowEAMType && userInfo.isEAMAccount && resp.userRouteInfoList.length == 1 && resp.userRouteInfoList[0].invalid != 0) {//帐号异常了  要么是失效2 要么是主帐号异常了1 0正常
                        auiDialog.warn('提醒', '您无权限访问管理中心，请联系您的帐号管理员。', function () {
                            AUI.BaseJSUtil.redirectUrl(sysUrlCfg.user.indexUrl);
                        });
                        defer.reject();
                    } else {
                        defer.resolve(resp);
                    }
                }
            }).catch(function (data) {
                if (data && data.NSP_STATUS && sysUrlCfg.developerStatus[data.NSP_STATUS + '']) {
                    // 跳到提醒会员资格已经被停用的页面
                    AUI.BaseJSUtil.redirectUrl(location.protocol + "//" + location.host +
                        "/consumer/cn/consolePortal/pagesubspend?developerStatus=" + data.NSP_STATUS);
                    return;
                }
                defer.reject();
            });
            return defer.promise;
        }

        function cancelDeveloperUpdate() {
            var defer = $q.defer();
            OpenUp.cancelDeveloperUpdate({req: {}}).then(function (data) {
                if (data.userID && data.resultCode == 0) {
                    var tmp = angular.copy(userInfo);
                    userInfo = {};
                    defer.resolve(tmp);
                } else {
                    defer.reject(userInfo);
                }
            }, function () {
                defer.reject(userInfo);
            });
            return defer.promise;
        }

        //获取俄罗斯个人的名称
        function getRuUserAuthInfo(userIDs) {
            var defer = $q.defer();
            if (userIDs && userIDs.length > 0) {
                OpenUp.getRuUserAuthInfo({req: {mainUserIDList: userIDs}}).then(function (data) {
                    if (data.userAuthInfos && data.userAuthInfos.length > 0) {
                        defer.resolve(data.userAuthInfos);
                    } else {
                        defer.resolve([]);
                    }
                }, function () {
                    defer.resolve([]);
                });
            } else {
                defer.resolve([]);
            }
            return defer.promise;
        }

        function getIsLegalRole() {
            var defer = $q.defer();
            auiTeamAccountService.getCurrentUserRole().then(function (teamRoleList) {
                defer.resolve(AUI.BaseJSUtil.contains(teamRoleList, 'LegalSpecialist'));
            });
            return defer.promise;
        }

        function getIsAdminRole() {
            var defer = $q.defer();
            auiTeamAccountService.getCurrentUserRole().then(function (teamRoleList) {
                defer.resolve(AUI.BaseJSUtil.contains(teamRoleList, 'Admin'));
            });
            return defer.promise;
        }

        function getAgeGroupFlag(req) {
            var defer = $q.defer();
            OpenUp.getAgeGroupFlag(req).then(function (data) {
                if (data && data.resultCode == 0) {
                    defer.resolve(data.ageGroupFlag);
                }
            });
            return defer.promise;
        }

        //检查邮箱是否和UP邮箱是否一致email,accountEmail
        function checkIsSameWithUPEmail(email, accountEmail) {
            return email == accountEmail;
        }

        //检查手机号是否和UP手机号是否一致phone,accountPhone 去掉0086的情况
        function checkIsSameWithUPPhone(phone, accountPhone) {
            return phone == accountPhone;
        }

        function getAccountBaseInfo() {
            var defer = $q.defer();
            //成员帐号不能掉
            if ((!userInfo.loginUserName || !userInfo.nationalCode) && !AUI.HDGWCall.getUserInfoValue('teamid')) {
                OpenUp.getAccountBaseInfo({req: {}}).then(function (res) {
                    if (res && res.resultCode == 0) {
                        constructUserInfo(userInfo, res);
                        defer.resolve(userInfo);
                    }
                }).catch(function () {
                    defer.resolve(userInfo);
                });
            } else {
                defer.resolve(userInfo);
            }
            return defer.promise;
        }


        function userAcctInfoList() {
            var defer = $q.defer();
            //成员帐号不能掉
            if ((!userInfo.accountEmail || !userInfo.accountPhone) && !AUI.HDGWCall.getUserInfoValue('teamid')) {
                OpenUp.userAcctInfoList({req: {}}).then(function (res) {
                    if (res && res.resultCode == 0) {
                        constructAcctInfo(userInfo, res.accountInfoList);
                        defer.resolve(userInfo);
                    }
                }).catch(function () {
                    defer.resolve(userInfo);
                });
            } else {
                defer.resolve(userInfo);
            }
            return defer.promise;
        }

        function getMerchantContactList() {
            var defer = $q.defer();

            //成员帐号不能掉
            OpenUp.getMerchantContactList({req: {}}).then(function (res) {
                if (res && res.resultCode == 0) {
                    userInfo.contactInfo = res.contacts;
                    defer.resolve(userInfo);
                }
            }).catch(function () {
                defer.resolve(userInfo);
            });
            return defer.promise;
        }

        function getTaxInfo() {
            var defer = $q.defer();
            //成员帐号不能掉
            OpenUp.getTaxInfo({req: {}}).then(function (res) {
                if (res && res.resultCode == 0) {
                    userInfo.userTaxInfo = res.taxInfo;
                    defer.resolve(userInfo);
                }
            }).catch(function () {
                defer.resolve(userInfo);
            });
            return defer.promise;
        }

        function checkIsLegalManMaximizing() {
            var defer = $q.defer();
            //成员帐号不能掉
            OpenUp.checkIsLegalManMaximizing({req: {}}).then(function (res) {
                if (res && res.resultCode == 0) {
                    defer.resolve(res.isLegalManMaximizing);
                } else {
                    defer.resolve(0);
                }
            }).catch(function () {
                defer.resolve(0);
            });
            return defer.promise;
        }


        /**
         * 获取华为云实名认证状态
         * @returns {any} 实名认证结果
         */
        function getHwcloudVerifyState() {
            if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                return;
            }
            var defer = $q.defer();
            OpenUp.getHwcloudVerifyState({req: {}}).then(function (res) {
                defer.resolve(res);
            }).catch(function () {
                defer.resolve(0);
            });
            return defer.promise;
        }

        //同步华为帐号团队帐号的接口
        function syncManagedIDUserInfo() {
            if (AUI.HDGWCall.getUserInfoValue('teamid') && !userInfo.isEAMAccount) {//调用OpenCommon 拉取数据 当是普通的成员帐号的时候不拉取
                return;
            }
            var defer = $q.defer();
            OpenOther.syncManagedIDUserInfo({req: {}}).then(function (res) {
                defer.resolve(res);
            }).catch(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        function getAcceptEDM() {
            var defer = $q.defer();
            OpenUp.getAcceptEDM({req: {}}).then(function (res) {
                defer.resolve(res);
            }).catch(function () {
                defer.resolve(0);
            });
            return defer.promise;
        }

        function initHianalytics() {
            var portal_analytic_config = {
                setTrackerUrl: sysUrlCfg.bianalyticUrl.setTrackerUrl,//上报地址
                setSiteId: "developer.huawei.com" + sysUrlCfg.bianalyticUrl.setSiteId// 被跟踪网站ID：网站域名
            }
            var hasdk = window.hasdk = _hasdk || [];

            function $device_hwanalytics() {
                var arrStr = {};
                return new function () {
                    this.init = function (config) {
                        // 加载服务端JS
                        hasdk.push(['setOnReportUrl', config.setTrackerUrl]);
                        hasdk.setOnReportUrl(config.setTrackerUrl);
                        hasdk.push(['setIdsite', config.setSiteId]);
                        hasdk.setIdsite(config.setSiteId);
                    };
                    this.trackPageView = function (title, tagType) {//访问事件
                        if (title) {
                            this.initArr();
                            hasdk.setTitle(title);
                            this.setCustomVariable("serviceItem", 1);
                            tagType && this.setCustomVariable("tagType", tagType);
                        }
                        hasdk.setPageData(JSON.stringify(arrStr));
                        hasdk.sendData();
                        this.initArr();
                    };
                    this.initArr = function (domain) {
                        arrStr = {};
                        var lan = 'zh';
                        arrStr["language"] = lan;
                        if (domain) {
                            arrStr["domain"] = domain;
                        } else {
                            arrStr["domain"] = "dprm";
                        }

                    };
                    this.setCustomVariable = function (type, key) {
                        arrStr[type] = key.toString();
                    };
                    this.trackLink = function (key, tagType, serviceItem, clueExtendInfo, domain) {
                        if (key) {
                            this.initArr(domain);
                            hasdk.push(['setTitle', key]);
                            hasdk.setTitle(key);
                        }
                        if (tagType) {
                            this.setCustomVariable("tagType", tagType)
                        }
                        if (serviceItem) {
                            this.setCustomVariable("serviceItem", serviceItem);
                        }
                        if (clueExtendInfo) {
                            arrStr["clueExtendInfo"] = clueExtendInfo;
                        }
                        hasdk.sendClickData("", "", "", JSON.stringify(arrStr));
                        this.initArr();
                    };
                }
            }

            var config = portal_analytic_config;
            var hianalytics = $device_hwanalytics();
            hianalytics.init(config);
            window.hianalytics = hianalytics;
        }

        return {
            get: get,
            getNickName: getNickName,
            updateCache: updateCache,
            updateUser: updateUser,
            promise: promise,
            updateBank: updateBank,
            logOut: logOut,
            allowLogin: allowLogin,
            changeNameFun: changeNameFun,
            getWhiteListCache: getWhiteListCache,
            getUserRouteInfo: getUserRouteInfo,
            cancelDeveloperUpdate: cancelDeveloperUpdate,
            getAgeGroupFlag: getAgeGroupFlag,
            getUserInfo: getUserInfo,
            checkIsSameWithUPEmail: checkIsSameWithUPEmail,
            checkIsSameWithUPPhone: checkIsSameWithUPPhone,
            getAccountBaseInfo: getAccountBaseInfo,
            userAcctInfoList: userAcctInfoList,
            getMerchantContactList: getMerchantContactList,
            getTaxInfo: getTaxInfo,
            getUserAllRouteInfo: getUserAllRouteInfo,
            checkIsLegalManMaximizing: checkIsLegalManMaximizing,
            getHwcloudVerifyState: getHwcloudVerifyState,
            syncManagedIDUserInfo: syncManagedIDUserInfo,
            getAcceptEDM: getAcceptEDM,
            initHianalytics: initHianalytics
        }

    }
    ])
        ;
})
;


